import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "auth-page" }
const _hoisted_2 = { class: "auth-card" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "error-message"
}

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/store/auth'
import axios from 'axios'
import { api } from '@/api/http'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const router = useRouter()
const authStore = useAuthStore()

const form = ref({
  username: '',
  password: ''
})

const loading = ref(false)
const error = ref('')

const handleSubmit = async () => {
  loading.value = true
  error.value = ''

  try {
    const { data } = await api.post('/auth/login', form.value)

    authStore.login(data.user, data.access_token)

    router.push(data.user.role === 'ADMIN' ? '/' : '/admin')
  } catch (err: unknown) {
    if (axios.isAxiosError(err)) {
      error.value = err.response?.data?.message || 'Неверный логин или пароль'
    } else {
      error.value = 'Неверный логин или пароль'
    }
  } finally {
    loading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "auth-title" }, "Авторизация", -1)),
      _createElementVNode("form", {
        onSubmit: _withModifiers(handleSubmit, ["prevent"]),
        class: "auth-form"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("label", { class: "form-label" }, "Логин", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.username) = $event)),
            type: "text",
            class: "form-input",
            required: "",
            placeholder: "Введите логин"
          }, null, 512), [
            [_vModelText, form.value.username]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("label", { class: "form-label" }, "Пароль", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.password) = $event)),
            type: "password",
            class: "form-input",
            required: "",
            placeholder: "Введите пароль"
          }, null, 512), [
            [_vModelText, form.value.password]
          ])
        ]),
        _createElementVNode("button", {
          type: "submit",
          class: "submit-btn",
          disabled: loading.value
        }, _toDisplayString(loading.value ? 'Вход...' : 'Войти'), 9, _hoisted_5),
        (error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(error.value), 1))
          : _createCommentVNode("", true)
      ], 32)
    ])
  ]))
}
}

})